import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { TextField, Select, MenuItem } from '@mui/material';
import { GranitCategories, granitCategoriesLabels } from 'src/constants/category';
import { MenuProps } from './constants';

type TextureFiltersProps = {
  filter: string;
  setFilter: (filter: string) => void;
  categories: string[];
  setCategories: (categories: string[]) => void;
};

export const TextureFilters: React.FC<TextureFiltersProps> = ({
  filter,
  setFilter,
  categories,
  setCategories,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
      <TextField
        id="outlined-basic"
        label="Rechercher un mot clé..."
        variant="outlined"
        sx={{
          width: '75%',
          input: {
            color: '#98A2B3',
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
          },
        }}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        InputProps={{
          startAdornment: <SearchIcon style={{ color: '#98A2B3' }} />,
        }}
      />

      <Select
        style={{ height: '50px', width: '100px' }}
        value={categories}
        multiple
        onChange={(e) => {
          setCategories(e.target.value as string[]);
        }}
        MenuProps={MenuProps}
      >
        {GranitCategories.map((el) => {
          const label = granitCategoriesLabels.find((l) => l.key === el)?.label ?? el;
          return (
            <MenuItem key={el} value={el}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};
